import { Maths } from 'helpers/maths';
import { getPlanProperties } from '../../helpers/dataHelpers';

// This field is on a 0-100 scale here (unlike the Plan's own `coveragePct`,
// a 0-1 fraction), so a missing/invalid value falls back to 100, matching
// this function's prior hardcoded default.
const toCoveragePercent = coveragePct =>
  coveragePct != null && Number.isFinite(coveragePct)
    ? Maths.multiplyRound(coveragePct, 100, 2)
    : 100;

// eslint-disable-next-line import/prefer-default-export
export const mapProperties = (
  cropZones,
  propertyLandingPageData,
  fieldsAndAreasGeoJSONCollection,
  values
) => {
  const mappedProperties = cropZones.map(cropZone => {
    const planProps = getPlanProperties(
      propertyLandingPageData,
      [cropZone.cropZoneIdValue],
      fieldsAndAreasGeoJSONCollection,
      values
    );
    return {
      areaType: cropZone?.boundaryAreaUnit || '',
      areaUnit: 'acres',
      areaValue: cropZone?.areaValue || '',
      boundaryArea: cropZone?.boundaryArea || '',
      coveragePct: toCoveragePercent(cropZone?.coveragePct),
      crop: {
        id: cropZone?.cropId || '',
        name: ''
      },
      cropZoneId: cropZone?.cropZoneIdValue || '',
      farmId: planProps[0]?.farmId || '',
      name: cropZone?.name || '',
      reportedArea: cropZone?.reportedArea || ''
    };
  });

  return mappedProperties;
};
